import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ActionListArchivedService {

  constructor(
    private _http: HttpClient
  ) { }

  getArchivedActionLists(organizationId) {
    return this._http.get(environment.url + "/actionTypes/archived/" + organizationId);
  }

  restoreArchivedActionList(requestData) {
    return this._http.put(environment.url + "/actionTypes/restore", requestData, { headers: { "hideLoader": "true" }});
  }

  getDeletedActionLists(organizationId){
    return this._http.get(environment.url + "/actionTypes/deleted/" + organizationId);
  }
  
  getActionTypes(id) {
    return this._http.get(environment.url + "/actionTypes/" + id);
  }

}
